






import { Component, Vue } from 'vue-property-decorator'
import LinkListMixin from '@/components/link/LinkListMixin.vue'

@Component({
  components: {
    LinkListMixin,
  },
  computed: {},
})
export default class Link extends Vue {}
